import { makeGqlQuery } from '@/utilities/gqlQuery';
import { gql } from '@/utilities/gql';
import { NARRATIVE_FRAGMENT } from './narrativeFragment';
import type { ResolvedQueryData } from '@/utilities/genericTypes';
import { NARRATIVE_URL_COMPANY_FRAGMENT } from '../../utils/getNarrativeUrl';
import { NARRATIVE_SIDEBAR_COMPANY_FRAGMENT } from '../../components/NarrativeSidebar/narrativeSidebarFragment';
import { COMMENT_SCHEMA_FRAGMENT } from '@/utilities/comment';
import { NARRATIVE_UPDATE_PANEL_FRAGMENT } from '../../components/NarrativeUpdatePanel';
import { FAIR_VALUE_HISTORY_GRAPH_NARRATIVE_FRAGMENT } from '../../components/FairValueHistoryGraph/narrativeFragment';
import { NARRATIVE_EDIT_BUTTON_FRAGMENT } from '../../components/NarrativeEditButton';
import { USE_EXISTING_NARRATIVE_REDIRECT_COMPANY_FRAGMENT } from '../useExistingNarrativeRedirect';

const QUERY = gql(
  `
 query Narrative($slug: ID!, $ref: String!) {
    narrative(ref: $slug) {
      commentKey
      commentCount
      ...NarrativeFields
      ...FairValueHistoryGraphNarrativeFields
      ...NarrativeEditButtonFields
      company {
        analysisValue {
          priceTargetAnalystCount
        }
        canonicalCommunityUrl
        ...NarrativeSidebarCompanyFields
        ...NarrativeUrlCompanyFields
        ...UseExistingNarrativeRedirectCompanyFields
      }
      comments(limit: 5) {
        ...CommentSchemaFields
      }
    }
    narrativeUpdates(first: 50, filter: { narrativeRefs: [$ref], skipEarliest: true }) {
      edges {
        node {
          ...NarrativeUpdatePanelFields
        }
      }
    }
  }
`,
  [
    USE_EXISTING_NARRATIVE_REDIRECT_COMPANY_FRAGMENT, // TODO This fragment is not needed for the narrative page, remove when PublicNarrativeEdit is not longer using useNarrative query
    NARRATIVE_FRAGMENT,
    NARRATIVE_SIDEBAR_COMPANY_FRAGMENT,
    NARRATIVE_URL_COMPANY_FRAGMENT,
    COMMENT_SCHEMA_FRAGMENT,
    NARRATIVE_UPDATE_PANEL_FRAGMENT,
    FAIR_VALUE_HISTORY_GRAPH_NARRATIVE_FRAGMENT,
    NARRATIVE_EDIT_BUTTON_FRAGMENT,
  ]
);

export const useNarrative = makeGqlQuery(QUERY, {
  staleTime: 3600000,
  tags: ['narrative', 'narrative-view'],
});

export type Narrative = ResolvedQueryData<typeof useNarrative>['narrative'];
export type NarrativeUpdate = ResolvedQueryData<
  typeof useNarrative
>['narrativeUpdates']['edges'][number]['node'];
